import { useTypedSelector } from '../reducers';

export default function useIsAuthenticated() {
  return useTypedSelector(
    (state) => !!state.auth.user?.id && Array.isArray(state.auth.user.roles),
  );
}
